if (typeof window !== "undefined") {
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest('[data-pagination] a[sprig]');

        if (!trigger) {
            return;
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
    });
}
